module.exports = __webpack_public_path__ + "img/2.53b4f5c3.jpg";